import React from "react";
import styles from "./projects.module.css";
import { Container } from "react-bootstrap";
import { MdOutlineArrowOutward } from "react-icons/md";
import { Heading, Paragraph } from "../TextComponents/TextComponents";
import { useNavigate } from "react-router-dom";

const AllProjects = () => {
  const navigate = useNavigate();
  const sections = [
    {
      title: "EHP Technology",
      description:
        "EHP is the world's fastest, most cost-effective, simplest, cheapest, three-phase single heat transfer technology that can operate in various geometric shapes without the need for secondary processing.",
      image: "/images/project/img_1.png",
    },
    {
      title: "Extracting Elements",
      description:
        "EHP is the world's fastest, most cost-effective, simplest, cheapest, three-phase single heat transfer technology that can operate in various geometric shapes without the need for secondary processing.",
      image: "/images/project/img_2.png",
    },
    {
      title: "Solar Energy",
      description:
        "EHP is the world's fastest, most cost-effective, simplest, cheapest, three-phase single heat transfer technology that can operate in various geometric shapes without the need for secondary processing.",
      image: "/images/project/img_3.png",
    },
    {
      title: "Wind Energy",
      description:
        "EHP is the world's fastest, most cost-effective, simplest, cheapest, three-phase single heat transfer technology that can operate in various geometric shapes without the need for secondary processing.",
      image: "/images/project/img_4.png",
    },
    {
      title: "Nuclear Grade Micro Grind Machine",
      description:
        "EHP is the world's fastest, most cost-effective, simplest, cheapest, three-phase single heat transfer technology that can operate in various geometric shapes without the need for secondary processing.",
      image: "/images/project/img_5.png",
    },
  ];

  const handleClick = () => {
    navigate(`/project/techdetails`);
  };

  return (
    <React.Fragment>
      <Container>
        <div className={styles.container}>
          <Heading>All Projects</Heading>{" "}
          <Paragraph color="#62677A">
            From energy solutions to technological advancements, our expertise
            <br /> spans diverse sectors.
          </Paragraph>
          {sections.map((section, index) => (
            <div
              key={index}
              onClick={() => handleClick(section, index)}
              className={styles.responsiveSection}
            >
              <div className={styles.responsiveImage}>
                <img
                  src={section.image}
                  alt={section.title}
                  className={styles.image}
                />
                <div className={styles.overlay}>
                  <div className={styles.textContent}>
                    <h2>
                      {" "}
                      {section.title} <MdOutlineArrowOutward />
                    </h2>

                    <p>{section.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </React.Fragment>
  );
};

export default AllProjects;
